import {Body1, Body2} from '@ui/atoms/typography';
import {TextField} from '@ui/molecules/field/textfield';
import React from 'react';

interface CheckInNameSectionProps {
  compact?: boolean;
  value: string;
  onChange: (value: string) => void;
  showValidation?: boolean;
}

export const CheckInNameSection = ({
  compact = false,
  value,
  onChange,
  showValidation,
}: CheckInNameSectionProps) => {
  const showError = showValidation && !value.trim();
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        {compact ? (
          <Body2 className="leading-[22px]" kind="blackTwo" weight="bold">
            Cycle name
          </Body2>
        ) : (
          <Body1 className="leading-6" kind="blackTwo" weight="bold">
            Cycle name
          </Body1>
        )}
        <Body2 className="leading-[22px]" kind="textBody">
          This is what participants will see when they receive the check-in.
        </Body2>
      </div>
      <TextField
        aria-label="Cycle name"
        aria-required="true"
        placeholder="e.g Operations weekly sync"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        state={showError ? 'error' : 'default'}
        helper={showError ? 'Enter a cycle name' : undefined}
        inputStyle={{
          borderRadius: '10px',
          ...(compact
            ? {
                height: '44px',
                padding: '5px 12px',
                fontSize: '16px',
                lineHeight: '24px',
              }
            : {}),
        }}
        margin
      />
    </div>
  );
};
